'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// ./~/_querystring@0.2.0@querystring/index.js
// module id = 871
// module chunks = 0